<template>
  <article class="my-meals-article">
    <input
      type="text"
      placeholder="Rechercher un plat, un ingrédient..."
      id="my-meals-search"
      ref="mealSearch"
      v-model="search"
      @input="onSearchChange()"
      @keyup.esc="resetSearch()"
    />
    <AddMealButton v-on:popup-opened="onAddMealClick" :isChooseView="false" />
    <!-- Affichage de tous les meals -->
    <SwitchButton
      class="show-all-workspaces"
      v-model="showAllWorkspaces"
      text="Afficher tous les espaces"
      :textBefore="false"
    />
    <!-- Liste -->
    <MealList
      class="meal-list"
      v-if="meals !== null"
      :meals="meals"
      :clickable="false"
      :updatable="true"
      :emptyMsg="emptyMsg"
      @click="(meal) => $emit('click', meal)"
    />
  </article>
</template>

<script>
import * as fb from '../../firebase';
import MealList from './MealList.vue';
import AddMealButton from '../Form/AddMealButton.vue';
import SwitchButton from '../Form/SwitchButton.vue';
import workspaceService from '../../services/workspace.service';

export default {
  components: {
    MealList,
    AddMealButton,
    SwitchButton,
  },
  props: {},
  data() {
    return {
      snapshotUnsub: null,
      allMeals: [],
      meals: null,
      search: '',
      showAllWorkspaces: true,
    };
  },
  mounted() {
    this.getMeals();
    // Uniquement en mode PC, on focus
    if (!this.isTouchDevice) {
      this.$nextTick(() => this.$refs.mealSearch.focus());
    }
  },
  destroyed() {
    this.unsub();
  },
  methods: {
    getMeals() {
      this.unsub();
      this.allMeals = [];
      this.meals = [];
      if (!this.currentWorkspaceRef) {
        return;
      }
      // Récupération des workspaces de l'user
      let allWorkspacesRef = workspaceService.getWorkspacesRef(true);
      if (!this.showAllWorkspaces) {
        // En mode 1 seul workspace, on ne garde que le current workspace
        allWorkspacesRef = [this.currentWorkspaceRef];
      }

      // Recherche des meals de tous les workspaces
      this.snapshotUnsub = fb.mealsCollection
        .where('workspace', 'in', allWorkspacesRef)
        .orderBy('createdOn', 'desc')
        .onSnapshot((snapshot) => {
          const meals = [];
          snapshot.forEach((doc) => {
            const meal = doc.data();
            meal.id = doc.id;
            meals.push(meal);
          });
          // All meals & meals identique par défaut
          this.allMeals = meals;
          this.meals = meals;
        });
    },
    unsub() {
      if (this.snapshotUnsub) {
        this.snapshotUnsub();
      }
    },
    onSearchChange() {
      // Si vide, on gagne du temps
      if (this.search === '') {
        this.meals = this.allMeals;
        return;
      }
      // Sinon on calcule
      const simplifyStr = (str) => {
        // en minuscule, sans accents
        if (str) {
          return str
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        }
        return '';
      };
      const searchVal = simplifyStr(this.search);
      this.meals = this.allMeals.filter((meal) => {
        // Si le titre contient le texte
        const isTitle = simplifyStr(meal.title).includes(searchVal);
        // Ou un des ingrédients
        const subIngredients = meal.ingredients
          .map((ing) => ing.title)
          .filter((ingredient) => simplifyStr(ingredient).includes(searchVal));
        const isIngredient = subIngredients.length > 0;
        return isTitle || isIngredient;
      });
    },
    resetSearch() {
      this.search = '';
      this.onSearchChange();
    },

    onAddMealClick() {
      // on vide la zone de recherche
      this.resetSearch();
    },
  },
  computed: {
    emptyMsg() {
      return this.allMeals.length > 0
        ? 'Aucun élément ne correspond à votre recherche'
        : "La liste est vide, ajoutez d'abord un repas !";
    },
  },
  watch: {
    currentWorkspace() {
      this.getMeals();
    },
    showAllWorkspaces() {
      this.getMeals();
    },
  },
};
</script>

<style lang="scss" scoped src="./MyMeals.scss"></style>
